<template>
    <v-container class="fill-height back" fluid>
      <v-app-bar clipped-left app flat dark color="transparent">
        <img @click="home" class="logo" height="36" src="https://irsx.sgp1.digitaloceanspaces.com/irmalogoputih.png" alt="logo"/>
        <v-spacer/>
        <v-toolbar-items>
          <v-btn text>Fitur</v-btn>
          <v-btn @click="login" text>Login</v-btn>
          <v-btn @click="register" text>Register</v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md6 lg6>
            <v-card class="elevation-1">
              <v-layout  wrap>
                <div class="primary layout align-center hidden-sm-and-down hidden-md-and-down">
                  <v-img
                    src="../assets/imagelogin.png"
                    max-height="300"
                    contain
                    width="300">
                    </v-img>
                </div>
                <v-flex  xs12 sm12 md12 lg6 >
                      <h1 class="text-center primary--text  mt-5">SignUp</h1>
                  <v-card-text>
                      <v-form v-model="valid" ref="form" lazy-validation>
                        <v-text-field
                          v-model="newdata.name"
                          name="name"
                          :rules="Rules"
                          required
                          label="Name"
                        ></v-text-field>
                        <v-text-field
                          v-model="newdata.email"
                          name="email"
                          :rules="emailRules"
                          required
                          type="email"
                          label="Email"
                        ></v-text-field>
                        <v-text-field
                          v-model="newdata.phone"
                          name="phone"
                          :rules="Rules"
                          required
                          type="phone"
                          label="Phone Number"
                        ></v-text-field>
                        <v-text-field
                          v-model="newdata.password"
                          name="password"
                          :rules="Rules"
                          required
                          type="password"
                          label="Password"
                        ></v-text-field>
                        <v-text-field
                          v-model="newdata.confmpassword"
                          name="confmpassword"
                          :rules="Rules"
                          required
                          type="password"
                          label="Confm Password"
                        ></v-text-field>
                        <v-checkbox
                          label="By signing up, you agree to the Terms of Service and Privacy Policy"
                          v-model="checkbox"
                          :rules="[(v) => !!v || 'You must agree to continue!']"
                          required
                        ></v-checkbox>
                        <v-card-actions>
                          <v-btn
                            block
                            class="primary"
                            :disabled="!valid"
                            @click.native="handleSubmit()"
                            :loading="loading"
                          >Sign UP</v-btn>
                        </v-card-actions>
                        <div style="height:20px"></div>
                        <a href="#" class="magneta" @click.prevent="loginform()">Login to Accounnt</a>
                        <div style="height:20px"></div>
                      </v-form>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'signup',
  data: () => ({
    valid: false,
    checkbox: false,
    newdata: {
      name: '',
      email: '',
      phone: '',
      password: '',
      confmpassword: ''
    },

    emailRules: [
      v => !!v || 'E-mail is required',
      v =>
        // eslint-disable-next-line no-useless-escape
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'E-mail must be valid'
    ],

    Rules: [v => !!v || 'Please fill'],
    submitted: false
  }),
  computed: {
    ...mapState('mitra', ['loading']),
    ...mapState('authentication', ['status', 'loading'])
  },
  created () {},
  methods: {
    ...mapActions({
      AddNew: 'mitra/Daftar',
      RegAkun: 'authentication/register'
    }),
    handleSubmit () {
      if (this.valid) {
        this.RegAkun(this.newdata)
        this.newdata.name = ''
        this.newdata.email = ''
        this.newdata.phone = ''
        this.newdata.password = ''
        this.newdata.confmpassword = ''
      }
    },
    loginform () {
      this.$router.push('/login')
    },
    register () {
      this.$router.push('/register')
    },
    forgot () {
      this.$router.push('/forgot')
    },
    home(){
      this.$router.push('/')
    },
    login(){
      this.$router.push("/login")
    },
  }
}
</script>

<style lang="stylus" scoped>
  .back {
    background-image: linear-gradient(to right, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url("https://irsx.sgp1.digitaloceanspaces.com/bglogintech.jpeg");
    background-size: cover;
  }
  a {
    text-decoration: none;
  }
</style>
